/**
 * /api-keys/new — thin route shim for the Create API key page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { CreateApiKeyPage } from "@/features/api-keys/pages/create-api-key-page";

export const Route = createFileRoute("/_authed/api-keys/new")({
  component: CreateApiKeyPage,
});
